// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"49ed4e9d","451":"9eeb93bd"}[chunkId] + ".chunk.js";
};